import { Box } from '@mui/material';
import React, { Component } from 'react';

import { loadExercisesByTags } from '../../api/exercises';
import { ProgramWeeks } from '../../api/programs.interface';
import ProgramDayCard from './ProgramDayCard';
import { createProgramTagNameLookup, getProgramWeekSchedule, getProgramWeekTagNumbers, PROGRAM_DAY_NUMBERS } from './programs.utils';

interface Props {
    onAddDay?: (day: number) => void;
    onDeleteDay?: (day: number) => void;
    onEditDay?: (day: number) => void;
    readOnly?: boolean;
    selectedWeek: number;
    variant?: 'builder' | 'detail';
    weeks: ProgramWeeks;
}

interface State {
    tagNamesByTag: Record<number, string>;
}

class ProgramWeekGrid extends Component<Props, State> {
    state: State = {
        tagNamesByTag: {},
    };

    componentDidMount() {
        this.loadTagNamesForWeek();
    }

    componentDidUpdate(prevProps: Props) {
        const previousTagKey = getProgramWeekTagNumbers(prevProps.weeks, prevProps.selectedWeek).join(',');
        const currentTagKey = getProgramWeekTagNumbers(this.props.weeks, this.props.selectedWeek).join(',');

        if (prevProps.selectedWeek !== this.props.selectedWeek || previousTagKey !== currentTagKey) {
            this.loadTagNamesForWeek();
        }
    }

    async loadTagNamesForWeek() {
        const tagNumbers = getProgramWeekTagNumbers(this.props.weeks, this.props.selectedWeek);

        if (!tagNumbers.length) {
            this.setState({ tagNamesByTag: {} });
            return;
        }

        const items = await loadExercisesByTags(tagNumbers);

        this.setState({ tagNamesByTag: createProgramTagNameLookup(items) });
    }

    render() {
        const { onAddDay, onDeleteDay, onEditDay, readOnly, selectedWeek, variant = 'detail', weeks } = this.props;
        const weekSchedule = getProgramWeekSchedule(weeks, selectedWeek);

        return (
            <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { lg: 'repeat(2, minmax(0, 1fr))', xs: 'minmax(0, 1fr)' } }}>
                {PROGRAM_DAY_NUMBERS.map((day) => (
                    <ProgramDayCard
                        day={day}
                        item={weekSchedule[String(day)]}
                        key={day}
                        onAddDay={onAddDay}
                        onDeleteDay={onDeleteDay}
                        onEditDay={onEditDay}
                        readOnly={readOnly}
                        tagNamesByTag={this.state.tagNamesByTag}
                        variant={variant}
                    />
                ))}
            </Box>
        );
    }
}

export default ProgramWeekGrid;